import { useComments } from "@/hooks/queries/useCollaboration"
import { useDtaComments } from "./DtaCommentsContext"
import "./SectionCommentBar.css"

/**
 * "All comments (N)" link shown next to a section title. Opens the rail listing every thread on the
 * DTA. Renders nothing when commenting isn't wired (no DtaCommentsProvider).
 */
export default function SectionCommentBar() {
  const rail = useDtaComments()
  // Version-scoped read, consistent with the rest of the editor's comment affordances: the count
  // covers the version currently being viewed.
  const { data } = useComments(rail?.dtaId ?? "", rail?.version ?? "")

  if (!rail) return null

  const total = data?.comments?.length ?? 0

  return (
    <button type="button" className="section-comment-link" onClick={() => rail.openRail()}>
      All comments ({total})
    </button>
  )
}
